module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-desktop@2x-c4ab6460c7e64e37e4604d759c5e5d85.webp";